import type { CityConfig } from "@/pages/city-template/types";

export const newburghConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Newburgh",
  state: "New York",
  stateAbbr: "NY",
  slug: "newburgh",
  route: "/newburgh",
  title: "Emergency Passport Newburgh, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Newburgh, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Newburgh, Stewart Airport travelers, Orange County families, and Hudson Valley professionals.",
  h1: "Emergency & Expedited Passport Services in Newburgh, NY",
  heroSubtitle: "Stewart International Airport is 5 miles from your doorstep. JFK and Newark are both under 70 miles. The Hudson River Valley's tri-airport advantage creates a unique passport urgency profile — and we help Newburgh residents, from historic waterfront families to Orange County commuters to West Point families, get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Newburgh%20New%20York%20along%20the%20Hudson%20River%20at%20golden%20hour%2C%20historic%20waterfront%20district%20with%20the%20Newburgh-Beacon%20Bridge%20spanning%20the%20river%2C%20Storm%20King%20Mountain%20and%20Hudson%20Highlands%20in%20background%2C%20charming%20brick%20architecture%20and%20marina%2C%20warm%20amber%20sunset%20light%20reflecting%20on%20the%20water%2C%20professional%20landscape%20photography%20with%20rich%20tones%20and%20dramatic%20sky%2C%20no%20text%20overlay&width=1800&height=700&seq=newburgh-hero-2026&orientation=landscape",
  heroImageAlt: "Newburgh New York Hudson River waterfront with Newburgh-Beacon Bridge at golden hour",
  geoPosition: "41.5034;-74.0104",
  geoPlacename: "Newburgh, New York",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~65 miles south in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Newburgh", zips: "12550, 12551, 12552, 12553, 12554, 12555" },
    { name: "Beacon", zips: "12508" },
    { name: "Cornwall", zips: "12518" },
    { name: "Middletown", zips: "10940, 10941" },
    { name: "Montgomery", zips: "12549" },
    { name: "Walden", zips: "12586" },
    { name: "New Windsor", zips: "12553" },
    { name: "Poughkeepsie", zips: "12601, 12602, 12603, 12604" },
    { name: "Wappingers Falls", zips: "12590" },
    { name: "Kingston", zips: "12401, 12402" },
    { name: "New Paltz", zips: "12561" },
    { name: "Goshen", zips: "10924" },
    { name: "Port Jervis", zips: "12771" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
    { name: "White Plains", zips: "10601, 10602, 10603, 10605, 10606, 10607, 10610" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Tri-Airport Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Newburgh-area travelers departing from SWF, JFK, or EWR with immediate travel needs." },
    { icon: "ri-flight-takeoff-line", title: "SWF Airport Expertise", desc: "Stewart International is 5 miles away with direct flights to Dublin, Orlando, Fort Lauderdale and connections worldwide. We know SWF airline timelines and last-minute boarding scenarios." },
    { icon: "ri-building-2-line", title: "Hudson Valley Professional Ready", desc: "Orange County professionals commuting to NYC, West Point families, and Hudson Valley executives — we handle the passport so you handle your life." },
    { icon: "ri-ship-line", title: "Newburgh Waterfront & Hudson River Travel", desc: "From the Newburgh riverfront to the Hudson Highlands, from weekend getaways to international cruises — we guide Hudson Valley travelers through every step." },
  ],
  internalLinks: [
    { name: "Fast passport services in New York City", route: "/new-york-city" },
    { name: "Expedited passport in White Plains, NY", route: "/white-plains" },
    { name: "Quick passport services in Poughkeepsie, NY", route: "/poughkeepsie" },
    { name: "Urgent passport services in Kingston, NY", route: "/kingston" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Newburgh via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Newburgh residents can ship from any UPS Store, FedEx Office, or post office location across Orange County.",
  fpcOfficeDistance: "Serving Newburgh, Beacon, Cornwall, Middletown, New Windsor, and all Orange County and Hudson Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Newburgh and all of Orange County. From the historic waterfront district to the suburban communities of New Windsor and Cornwall, from Beacon across the river to Middletown and Goshen — we serve the entire Hudson Valley corridor. Our courier service eliminates the need to drive to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Newburgh and all Orange County communities including Beacon, Cornwall, Middletown, New Windsor, Montgomery, Walden, Goshen, and Port Jervis. We also serve travelers departing from Stewart International Airport, JFK, and Newark who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Newburgh as simple as possible — with the efficiency and reliability Hudson Valley travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Newburgh travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Newburgh travelers encounter unique passport issues — everything from SWF same-day bookings to international connections through JFK. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Newburgh travelers — from waterfront residents to Cornwall families to West Point personnel — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Newburgh, NY? Here are the most common ones we hear from Orange County and Hudson Valley travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a SWF flight to Dublin, an emergency passport for a last-minute JFK international connection, or a first-time passport for a Hudson Valley family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "SWF flight to Dublin in three days? JFK international connection this weekend? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Newburgh-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Newburgh residents renew fast — no agency visit required for most renewals. Perfect for Orange County commuters, West Point families, and Hudson Valley professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Newburgh residents through every step — from the waterfront to New Windsor to Cornwall — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your SWF departure or JFK connection is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Hudson Valley family vacation stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Orange County professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Hudson Valley executives, consultants, and commuters who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Orange County travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Newburgh NY", description: "Urgent passport processing for Newburgh NY travelers with immediate departure needs from Stewart International Airport." },
    { name: "Expedited Passport Renewal Newburgh NY", description: "Fast passport renewal for Newburgh NY residents with a previously-issued passport." },
    { name: "First-Time Passport Newburgh NY", description: "New passport application services for Newburgh NY residents applying for their first passport." },
    { name: "Child Passport Newburgh NY", description: "Minor passport services for Newburgh NY families with children under 16." },
    { name: "Name Change Passport Newburgh NY", description: "Passport name correction after marriage, divorce, or legal name changes for Newburgh residents." },
    { name: "Second Passport Newburgh NY", description: "Second passport services for Newburgh executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Robert C.",
      location: "Newburgh, NY",
      rating: 5,
      text: "SWF flight to Dublin was booked 8 days out and my passport was expired. Fast Passport Center got it back in 48 hours. The document review caught a minor issue with my photo that would have been an automatic rejection.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Martinez Family",
      location: "New Windsor, NY",
      rating: 5,
      text: "We booked a family cruise departing from Florida and realized our two kids' passports were expired. Fast Passport Center walked us through the entire process and both passports arrived in 5 days. Saved our vacation.",
      service: "Child Passport Renewal",
    },
    {
      name: "Lisa M.",
      location: "Beacon, NY",
      rating: 5,
      text: "Needed a name change on my passport before a conference in London. They handled the entire process remotely — I never had to visit an office. The communication was excellent throughout.",
      service: "Name Change Passport",
    },
    {
      name: "James K.",
      location: "Cornwall, NY",
      rating: 5,
      text: "Third time using Fast Passport Center for Hudson Valley-to-Europe business trips. They know exactly what to do for SWF and JFK departures. Won't use anyone else in Orange County.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "newburgh-1",
      name: "Newburgh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 Broadway",
      city: "Newburgh",
      state: "NY",
      zip: "12550",
      phone: "(845) 561-8700",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM (appointment required)",
      distance: "Downtown Newburgh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Major Orange County passport acceptance facility. Passport photos available on-site. Busiest facility in the Newburgh area — book early during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "newburgh-2",
      name: "Middletown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17 James Street",
      city: "Middletown",
      state: "NY",
      zip: "10940",
      phone: "(845) 342-2767",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Middletown — west of Newburgh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Passport acceptance services available by appointment. Convenient for Middletown and western Orange County residents. Less crowded than Newburgh Main.",
      icon: "ri-mail-line",
    },
    {
      id: "newburgh-3",
      name: "Beacon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "369 Main Street",
      city: "Beacon",
      state: "NY",
      zip: "12508",
      phone: "(845) 831-5460",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Beacon — across the Hudson River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Beacon, Fishkill, and eastern Dutchess County. Convenient for Newburgh residents who prefer the Beacon side of the river. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "newburgh-4",
      name: "Cornwall Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "33 Quaker Avenue",
      city: "Cornwall",
      state: "NY",
      zip: "12518",
      phone: "(845) 534-9420",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Cornwall — south of Newburgh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Cornwall, Cornwall-on-Hudson, and southern Newburgh residents. Limited appointment slots — schedule in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "newburgh-5",
      name: "Orange County Clerk — Goshen",
      type: "County Clerk Passport Acceptance",
      address: "255 Main Street",
      city: "Goshen",
      state: "NY",
      zip: "10924",
      phone: "(845) 291-2690",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Goshen — Orange County seat",
      website: "https://www.orangecountygov.com/",
      websiteLabel: "Orange County Clerk",
      notes: "Orange County Clerk passport acceptance services. Convenient for Goshen, Chester, and western Orange County residents. No photo services on-site.",
      icon: "ri-government-line",
    },
    {
      id: "newburgh-6",
      name: "New Windsor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "374 Windsor Highway",
      city: "New Windsor",
      state: "NY",
      zip: "12553",
      phone: "(845) 561-0313",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "New Windsor — near SWF Airport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Closest acceptance facility to Stewart International Airport. Ideal for SWF travelers who need an acceptance clerk visit before an international flight.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to New York Passport Agency in Manhattan (~65 miles)", fpc: "Most Newburgh travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SWF & Tri-Airport Guidance", agency: "Generic — no SWF, JFK, or EWR airport expertise", fpc: "Full SWF/JFK/EWR tri-airport and Hudson Valley knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming SWF Handles International Connections Seamlessly",
      description: "Stewart International has limited international routes — many Newburgh travelers book SWF domestically and connect through JFK or EWR, not realizing their passport must be valid at the domestic departure point.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Newburgh applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Hudson Valley pharmacies and big-box stores produce photos that fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Orange County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Newburgh travelers booking to Ireland, the UK, or Europe often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or Hudson Valley location." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Newburgh clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Newburgh?", a: "We offer Newburgh-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Newburgh office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Newburgh post office or Orange County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Newburgh address." },
    { q: "Where can I get a passport acceptance in Newburgh?", a: "Newburgh has acceptance facilities at the Newburgh Main Post Office (215 Broadway), New Windsor Post Office (near SWF), Cornwall Post Office, Middletown Post Office, and the Orange County Clerk in Goshen. We maintain an updated list of Hudson Valley facilities." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency (located in Manhattan, ~65 miles from Newburgh) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "What is the best price for expedited passport service in Newburgh?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "Can I fly internationally from Stewart Airport (SWF)?", a: "SWF offers direct international flights to Dublin, Ireland via Norwegian and seasonal service to other destinations. For most international travel, Newburgh residents use SWF for domestic connections to JFK, EWR, or other international gateways. You need a valid passport at SWF regardless of connection plans." },
    { q: "Can I get a passport photo in Newburgh?", a: "Yes — many CVS, Walgreens, UPS Stores, and FedEx Office locations in Newburgh and throughout Orange County offer passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Newburgh passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Newburgh to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with passports for JFK International Airport travel?", a: "Yes. JFK is ~65 miles from Newburgh but is the primary international gateway for Hudson Valley travelers. We regularly assist Newburgh residents with expedited passports for JFK departures worldwide." },
    { q: "What about Newark Liberty (EWR) for Newburgh travelers?", a: "EWR is ~55 miles from Newburgh and is a convenient alternative for international flights. We help Newburgh residents coordinate passport timelines whether departing from SWF, JFK, or EWR." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Newburgh Residents",
    intro: "Newburgh's unique position in the Hudson Valley — with Stewart International Airport 5 miles away and JFK and Newark both within an hour's drive — creates distinct passport timing challenges. Here's what Newburgh travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF — Stewart International Airport",
        subtitle: "The Hudson Valley's international gateway, 5 miles from Newburgh",
        description: "Stewart International Airport serves Newburgh and the entire Hudson Valley with direct flights to Dublin, Orlando, Fort Lauderdale, and connecting service to major hubs. SWF's limited international route network means many Newburgh travelers fly domestically from SWF to connect at JFK or EWR — creating a critical passport check at the departure point. Norwegian's Dublin service generates steady passport urgency among Hudson Valley travelers.",
        tip: "SWF's TSA checkpoint requires valid ID for all passengers. If you are connecting internationally through another U.S. hub, your passport must be valid at the SWF departure gate — not just at the international connection.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "JFK — John F. Kennedy International Airport",
        subtitle: "NYC's primary international airport, ~65 miles from Newburgh",
        description: "JFK is the international workhorse for Hudson Valley travelers — direct flights to London, Paris, Tokyo, Dubai, and virtually every major world city. Newburgh residents who drive the 65 miles to JFK represent the largest single cohort of expedited passport requests from Orange County. The combination of a long drive and an international flight creates no room for a passport issue at the check-in counter.",
        tip: "JFK terminals are massive and check-in lines for international flights can exceed 90 minutes. Arriving at JFK with an expired passport means a 65-mile drive back to Newburgh with no flight — always verify your passport validity the moment you book.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "EWR — Newark Liberty International Airport",
        subtitle: "Northern New Jersey's international hub, ~55 miles from Newburgh",
        description: "Newark Liberty is a strong alternative for Hudson Valley travelers — closer than JFK for many Newburgh residents and serving as a United Airlines hub with direct flights to Europe, Asia, and South America. The Newburgh-to-Newark corridor via I-87 and I-78 makes EWR surprisingly accessible. Many Orange County professionals prefer EWR for business travel to London, Frankfurt, and Tokyo.",
        tip: "EWR's Terminal C (United) has some of the strictest passport validity enforcement in the region. United's international check-in system will flag an expiring passport immediately — often with no grace period for renewal.",
      },
      {
        icon: "ri-building-4-line",
        title: "West Point & Military Community Travel",
        subtitle: "U.S. Military Academy at West Point — 15 miles from Newburgh",
        description: "The U.S. Military Academy at West Point generates significant passport demand in the Newburgh area. Cadets studying abroad, military families relocating to overseas assignments, and visiting international dignitaries all create passport urgencies. West Point's trimester calendar and summer training schedules create compressed windows for international travel preparation.",
        tip: "Military-issued orders and PCS (Permanent Change of Station) assignments often have 2–4 week notice periods. Standard passport processing cannot meet these timelines — expedited courier service is essential for military families relocating from the West Point/Newburgh area.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The Hudson Valley Tri-Airport Advantage — and Its Passport Catch",
      description: "Having SWF, JFK, and EWR all within 70 miles of Newburgh is a remarkable travel advantage. But the tri-airport reality creates a specific passport risk: travelers who book international connections through JFK or EWR after a domestic SWF departure often discover at the SWF checkpoint that their passport has expired — grounding them before they ever reach the international connection.",
    },
  },
  destinations: {
    title: "Where Newburgh Travelers Go — And Why Passports Get Urgent",
    intro: "Newburgh's Hudson Valley location creates a distinctive mix of European heritage travel, Irish connections via SWF's Dublin route, and tri-airport access to worldwide destinations. Here's what drives passport urgency.",
    stats: [
      { stat: "38%", label: "of Newburgh expedited requests involve SWF-to-JFK/EWR domestic-international connections" },
      { stat: "2–4 Weeks", label: "average lead time Newburgh travelers have from trip booking to international departure" },
      { stat: "Jun–Aug", label: "peak season when SWF summer routes, family vacations, and West Point summer programs collide" },
      { stat: "28 Hours", label: "shortest turnaround we have accommodated for a Newburgh traveler departing SWF to Dublin" },
    ],
    destinations: [
      { name: "Ireland", context: "SWF direct Dublin flights, Irish diaspora heritage in the Hudson Valley, family reunions", urgency: "SWF seasonal schedule May–October creates narrow travel windows", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "JFK/EWR direct London flights, Hudson Valley business travel, heritage tourism", urgency: "Business meetings booked 2–3 weeks out with fixed dates", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "SWF seasonal Florida connections to Caribbean cruises, Orange County family resort vacations", urgency: "Last-minute cruise deals booked 3–4 weeks from departure", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "Hudson Valley wine and culinary tourism, European river cruises, anniversary trips", urgency: "Summer peak with tour groups requiring group passport coordination", icon: "ri-map-pin-2-line" },
      { name: "Germany & Central Europe", context: "Orange County manufacturing and engineering travel, Hudson Valley heritage tourism", urgency: "Trade fair and conference dates are fixed and unmovable", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal and Toronto weekend trips, Hudson Valley-to-Quebec driving vacations, business travel", urgency: "Cross-border road trips often booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Poughkeepsie", route: "/poughkeepsie" },
      { name: "Kingston", route: "/kingston" },
      { name: "Beacon", route: "/beacon" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Newburgh", address: "59 North Plank Road, Newburgh, NY 12550", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Newburgh", address: "454 Broadway, Newburgh, NY 12550", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — New Windsor", address: "374 Windsor Highway, New Windsor, NY 12553", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "The UPS Store — Newburgh", address: "1401 Route 300, Newburgh, NY 12550", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walgreens — Beacon", address: "320 Main Street, Beacon, NY 12508", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Middletown", address: "440 Route 211 East, Middletown, NY 10940", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Newburgh", address: "1401 Route 300, Newburgh, NY 12550", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "Walgreens — Middletown", address: "444 Route 211 East, Middletown, NY 10940", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Newburgh",
      address: "2 Dupont Avenue, Newburgh, NY 12550",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Middletown",
      address: "12 King Street, Middletown, NY 10940",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Full-service DMV office serving western Orange County. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "New York Stewart International Airport",
      distance: "About 5 miles from Newburgh",
      address: "1 Airport Road, New Windsor, NY 12553",
      note: "Hudson Valley's primary airport with direct flights to Dublin (Ireland), Orlando, Fort Lauderdale, and connecting service to major U.S. hubs. Closest airport to Newburgh — literally in New Windsor.",
      flightUrl: "https://www.swcairport.com/",
      flightLabel: "Stewart Airport Website",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "About 65 miles from Newburgh",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "NYC's primary international airport with direct flights worldwide. Most Newburgh international travelers use JFK for long-haul flights. Major international hub.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport Website",
      featured: false,
    },
    {
      code: "EWR",
      name: "Newark Liberty International Airport",
      distance: "About 55 miles from Newburgh",
      address: "3 Brewster Road, Newark, NJ 07114",
      note: "United Airlines international hub serving Europe, Asia, and South America. Convenient alternative for Newburgh area travelers — often closer than JFK.",
      flightUrl: "https://www.newarkairport.com/",
      flightLabel: "Newark Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Orange County residents can also contact the Orange County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Mail, online, and in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the City of Newburgh Clerk or the Orange County Clerk. Marriage records maintained by the municipality where the ceremony took place.",
      url: "https://www.orangecountygov.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce decrees through the Orange County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default newburghConfig;